<template>
<b-container
  class="bg-white py-5 d-flex section"
  fluid
>
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container class="p-md-5" fluid>
				<b-row>
					<b-col cols="12">
						<div class="d-flex">
							<div class="mx-auto py-5 text-center">
					<h1 class="font-weight-bold">TrinPod<sup>&trade;</sup></h1>
					<h1 class="font-weight-bold">One-World Model</h1>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="pb-5">
					<b-col
						cols="12"
						md="6"
						lg="5"
						offset-lg="2"
						class="py-5 
						pt-md-0 
						pb-md-5 
						order-2 
						order-md-1"
						>
						<p>Each TrinPod<sup>&trade;</sup> contains all the information, a one-world model, about an entity.</p> 
						
						<p>You can, for instance, have one TrinPod<sup>&trade;</sup> for your company. 
							Then use the TrinPod<sup>&trade;</sup> to contain all the information about your company. 
							You can store all the data created by all the Apps, in the one-world model, in your TrinPod<sup>&trade;</sup>. Then all the Apps share that data.</p>
						
						<p>Trinity keeps track of all the events in time, every change of any data for that company. 
							Trinity will create triples of your ideas.
							Trinity will use ontologies to conceptually understand the data and will relate it all to each other. 
							You are thereby creating a powerful, potent, one-world model of the company for you to access.</p>
						
						<p>And you can have a TrinPod<sup>&trade;</sup> for yourself. Your own (not Facebook or Twitters) world-model of your information. All your contacts, pictures, letters, emails, notes, comments, files, documents, work, and to-dos are all automatically linked and correlated by Trinity.</p>
					</b-col>
					<b-col
						cols="12"
						md="6"
						lg="3"
						class="order-1 order-md-2 text-center"
						>
						<b-img
							:src="require('../assets/one-world-illustration.png')"
							style="max-width: 360px; width: 100%; height: auto;"
							/>
					</b-col>
				</b-row>
      </b-container>

			<ImageWithButtonSection 
				sectionColorClass="bg-white"
				image="trinapp-oneworld_properties.png"
				figCaption="The One-World Model" 
				:industry="industry" 
			/>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
import ImageWithButtonSection from '@/components/image-with-button-section.vue';
export default {
	name: "OneWorldModel",
	props: {
		industry: String
	},
	components: {
		ImageWithButtonSection
	}
}
</script>
